

import { Component, Vue, Mixins } from 'vue-property-decorator'

import { IJob } from '@/features/job/store'
import { JOB_STATUSES } from '@/constants'
import { UPLOAD_NAME } from '@/features/upload/upload.router'
import Notification from '@/shared/Notification.mixin.vue'

@Component
export default class WatchOnJob extends Mixins(Notification) {
  public watchOnValidationFailedStatus (): Function {
    return this.$store.watch(({ job: jobState }) => jobState.job,
      ({ status }: IJob) => {
        if (status === JOB_STATUSES.VALIDATION_FAILED) {
          const message = this.$t(status) as string
          this.showError(message, () => this.$router.push({ name: UPLOAD_NAME }))
        }
      }, { immediate: true })
  }
}
